module.exports = __webpack_public_path__ + "static/media/WaveguideLightIcon.569d0fdc.svg";